import { isInIframe } from '@/helper/utils'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export default function IframeHeightReporter() {
  const router = useRouter()

  useEffect(() => {
    if (!isInIframe()) {
      return
    }

    const sendHeight = () => {
      // Calculate height based on actual content, not viewport-based min-height
      const mainContent = document.getElementById('app-main-content')
      const navbar = document.querySelector('nav')

      if (mainContent) {
        const navbarHeight = navbar?.offsetHeight || 96 // default navbar height
        const contentHeight = mainContent.scrollHeight
        const totalHeight = navbarHeight + contentHeight + 48 // 48px for padding
        window.parent.postMessage({ height: totalHeight }, '*')
      } else {
        // Fallback to body height with a reasonable cap
        const height = Math.min(document.body.scrollHeight, 2000)
        window.parent.postMessage({ height }, '*')
      }
    }

    document.body.classList.add('overflow-visible')

    const resizeObserver = new ResizeObserver(() => sendHeight())
    resizeObserver.observe(document.body)

    const handleRouteChange = () => {
      window.parent.postMessage({ height: 500, type: 'aloe-scroll-top' }, '*')
      setTimeout(() => {
        sendHeight()
      }, 200)
    }
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      resizeObserver.disconnect()
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  return null
}
